import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {IgxRippleModule, IgxTextSelectionDirective} from '@infragistics/igniteui-angular/directives';
import {IgxIconComponent} from '@infragistics/igniteui-angular/icon';
import {TranslateModule} from '@ngx-translate/core';
import {ClsConfig} from '../../../../util/cls-config';

@Component({
  selector: 'app-filtro-general-moderno',
  templateUrl: './filtro-general-moderno.component.html',
  styleUrls: ['./filtro-general-moderno.component.scss'],
  imports: [
    IgxIconComponent,
    TranslateModule,
    IgxTextSelectionDirective,
    IgxRippleModule
  ]
})
export class FiltroGeneralModernoComponent extends ClsConfig {
  @ViewChild('inputRef', {read: ElementRef, static: true})
  private inputRef: ElementRef<HTMLInputElement>;

  @Input()
  public descripcionLabel: string;
  @Input()
  public mostrarChkInicio = false;

  @Output()
  public enterPalabra: EventEmitter<string> = new EventEmitter<string>();
  @Output()
  public limpiarPalabras: EventEmitter<HTMLInputElement> = new EventEmitter<HTMLInputElement>();

  public chkBuscarInicio: boolean;
  public textToolTip = 'MENSAJES.GRALS.CONTIENE';

  public get input(): HTMLInputElement {
    return this.inputRef?.nativeElement as HTMLInputElement;
  }

  public cambiarBusquedaInicio() {
    this.chkBuscarInicio = !this.chkBuscarInicio;
    if (this.chkBuscarInicio) {
      this.textToolTip = 'MENSAJES.GRALS.CONTIENEINICIO';
    } else {
      this.textToolTip = 'MENSAJES.GRALS.CONTIENE';
    }
  }

  public onEnterBusPalabra(buscar: string) {
    this.enterPalabra.emit(buscar);
  }

  public onClearInput(input: HTMLInputElement) {
    input.value = '';
    this.limpiarPalabras.emit(input);
    input.focus();
  }

  public focusInput() {
    this.inputRef?.nativeElement.focus();
  }
}
